<template>
    <template v-if="verfuegbar">
        <div class="versicherungs-button col col-12 col-md-6" role="button" tabindex="0" @click="$emit('select')" @keydown.enter="$emit('select')" @keydown.space.prevent="$emit('select')">
            <input type="checkbox" :id="`s2-${itemId}`" class="d-none" :checked="selected">
            <label class="d-flex flex-column p-3 border rounded w-100">
                <div class="d-flex justify-content-between align-items-center">
                    <zwei_bettzimmer_icon></zwei_bettzimmer_icon>
                    <h1>{{ beitragStr }}</h1>
                </div>
                <h3 class="mt-2">2-Bettzimmer</h3>
            </label>
        </div>
    </template>
</template>

<script setup>
import zwei_bettzimmer_icon from "@/components/icons/zwei_bettzimmer_icon.vue";

defineProps({
    itemId: {
        type: String,
        required: true
    },
    beitragStr: {
        type: String,
        default: '- €'
    },
    selected: {
        type: Boolean,
        default: false
    },
    verfuegbar: {
        type: Boolean,
        default: true
    }
})

defineEmits(['select'])
</script>

<style scoped>
    h1, h3 {
        white-space: nowrap;     
        overflow-wrap: normal;   
        word-break: none;      
        hyphens: none;          
    }
</style>
